export default function openWithApp(osCode, scheme, customUrl, packageName, useIntent = true, isKakaoTalk = false) {
  const intentUrl = `intent://${customUrl}#Intent;scheme=${scheme};package=${packageName};end`;
  const customScheme = `${scheme}://${customUrl}`;

  if (isKakaoTalk || osCode === 'iOS') {
    window.location = customScheme;
  } else if (osCode === 'Android') {
    window.location = useIntent ? intentUrl : customScheme;
  } else {
    alert(`지원하지 않는 플랫폼입니다. (${osCode})`);
  }
}



// WEBPACK FOOTER //
// ./src/utils/openWithAppWithoutInstall.js